<script lang="ts">
  import type { Product } from '$lib/interfaces';
  import ItemGrid from './ItemGrid.svelte';
  import ProductViewer from './ProductViewer.svelte';

  export let products: Product[] | undefined;
  export let currentPage = 1;
  export let hasNext = false;
  export let testAppId: string | undefined = undefined;
</script>

<ItemGrid items={products} {currentPage} {hasNext} on:change let:item>
  <slot name="empty" slot="empty" {currentPage} />
  <ProductViewer product={item} {testAppId} hoverEffects />
</ItemGrid>
